export default __webpack_public_path__ + "static/media/ConfigScalyrAgentK8s.eb64c699.md";